import { Component, OnInit, ViewChild } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { base64ToArrayBuffer, saveByteArrayAnyFileType } from 'app/helpers/blobDownload';
import { ExposedListFMEReportsRes } from 'app/interfaces/responses/Exposed/exposedListFMEReportsRes';
import { ExposedListMessageLogRes } from 'app/interfaces/responses/Exposed/exposedListMessageLogRes';
import { LoansService } from 'app/services/api/loans/loans.service';
import { SkjalamidjaService } from 'app/services/api/skjalamidja/skjalamidja.service';
import { TranslationService } from 'app/services/api/translation/translation.service';
import { AlertsService } from 'app/services/system/alerts/alerts.service';
import { PROCESSING_STATUS } from 'common/constants/queue.constants';

@Component({
    selector: 'loans-fme-report',
    templateUrl: './loans-fme-report.component.html',
})
export class LoansFMEReport implements OnInit {
    // Reports table
    @ViewChild(MatSort) reportsSort: MatSort;
    @ViewChild('reportsPaginator ') reportsDataPaginator: MatPaginator;
    reports: ExposedListFMEReportsRes[];
    reportsData: MatTableDataSource<ExposedListFMEReportsRes> = new MatTableDataSource();
    reportsColumns: string[] = ['generatedAt', 'title', 'actions'];
    // Message table
    messages: ExposedListMessageLogRes[];
    messagesData: MatTableDataSource<ExposedListMessageLogRes> = new MatTableDataSource();
    messagesColumns: string[] = ['id', 'title', 'status', 'created_at'];

    pageSize: number = 25;
    // Determines if a report is currently being processed or not
    isProcessingReport: boolean = false;
    processingStatus = PROCESSING_STATUS;

    lastMonthDate = new Date();

    constructor(
        private loansService: LoansService,
        private skjalamidja: SkjalamidjaService,
        private alertsService: AlertsService,
        private translationService: TranslationService
    ) {
        // Sets the date to the last day of the previous month
        this.lastMonthDate.setDate(0);
    }

    ngOnInit(): void {
        this.refresh();
    }

    refresh(): void {
        let requestPromises = [
            this.loansService.getFMEReportList(this.reports == null),
            this.loansService.getRunningFMEReportGenerationMessages(this.messages == null),
        ];

        Promise.all(requestPromises).then(([reports, messages]) => {
            this.reports = reports as ExposedListFMEReportsRes[];
            this.messages = messages as ExposedListMessageLogRes[];

            this.reportsData.data = this.reports;
            this.messagesData.data = this.messages;

            this.isProcessingReport = messages.length > 0;
            // If a report is currently being processed the data is refreshed regularly until the new report is ready
            if (this.isProcessingReport) {
                setTimeout(() => {
                    this.refresh();
                }, 30 * 1000);
            }
        });
    }

    ngAfterViewInit(): void {
        this.reportsData.sort = this.reportsSort;
        this.reportsData.paginator = this.reportsDataPaginator;
    }

    onQueueGeneration = () => {
        this.loansService.generateFMEReport().then((res) => {
            this.refresh();
        });
    };

    onFetchXML = (item: ExposedListFMEReportsRes) => {
        this.loansService.getFMEReportDocument(item.id, item.xmlDocumentId).subscribe((fileRes) => {
            var sampleArr = base64ToArrayBuffer(fileRes.base64File);
            saveByteArrayAnyFileType(fileRes.fileName, sampleArr, 'application/xml');
            this.alertsService.changeAlertShowIcon(true);
            this.alertsService.changeAlertSuccessMessage('Skjalinu hefur verið hlaðið niður í vafrann þinn');
            this.alertsService.changeAlertSuccessShow(true);
        });
    };

    onFetchExcel = (item: ExposedListFMEReportsRes) => {
        this.loansService.getFMEReportDocument(item.id, item.excelDocumentId).subscribe((fileRes) => {
            var sampleArr = base64ToArrayBuffer(fileRes.base64File);
            saveByteArrayAnyFileType(fileRes.fileName, sampleArr, 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet');
            this.alertsService.changeAlertShowIcon(true);
            this.alertsService.changeAlertSuccessMessage('Skjalinu hefur verið hlaðið niður í vafrann þinn');
            this.alertsService.changeAlertSuccessShow(true);
        });
    };

    getMessageTitle = (message: ExposedListMessageLogRes) => {
        var body = JSON.parse(JSON.parse(message.payload).Body);
        return `${this.translationService.translate('label_report')}- ${body.Year}/${body.Month}`;
    };
}
